import Dexie from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";
import { DexieIndexKeys } from "../../dexie-index-keys";

/**
 * Defines the upgrade path for version 12 of indexed DB.
 * Adds compound indexes to DispatchedServiceSyncData table for improved query performance.
 */
export class DatabaseUpgradeV12 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 12;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).stores({
			DispatchedServiceSyncData: `${DexieIndexKeys.ID}, ${DexieIndexKeys.LEGACY_ID}, [${DexieIndexKeys.USER_NAME}+${DexieIndexKeys.CROWN_ID}], [${DexieIndexKeys.USER_NAME}+${DexieIndexKeys.CROWN_ID}+${DexieIndexKeys.SYNC_TYPE}]`
		});
	}
}
